module.exports = __webpack_public_path__ + "img/construction.b9ad8744.png";